import { audioType } from '../../../../texas/interfaces'

export default function handleLeftActions(
  audio: audioType,
  gameState: number,
  handleUndo: () => void,
  handleFold: () => void,
  handleCheck: () => void,
  playUndoSFX: () => void,
  playFoldlSFX: () => void,
  playCheckSFX: () => void,
  setIsClickable: (b: boolean) => void,
) {
  switch (gameState) {
    case 0:
    case 5:
    case 6:
    case 11:
      handleUndo()
      audio?.sound && playUndoSFX()
      break
    case 4:
      handleFold()
      audio?.sound && playFoldlSFX()
      break
    case 14:
    case 15:
      handleCheck()
      setIsClickable(true)
      setTimeout(() => {
        setIsClickable(false)
      }, 500)
      audio?.sound && playCheckSFX()

      break
    default:
      break
  }
}

// if (gameState === 0) {
//   handleUndo()
//   // audio?.sound && playUndoSFX()
// } else if (gameState === 4) {
//   // setIsClickable(true)
//   handleFold()
//   // handleIsFolded(true)
//   // handleDealOut(true)
//   // handleClearCards(1000)
//   // audio?.sound && playFoldlSFX()
// } else {
//   // setIsClickable(true)
//   // handleNewBet()
//   // handleDealOut(true)
//   // handleClearCards(1000)
//   // handleActive('ante')
//   // audio?.sound && playnewBetSFX()
// }
